import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp, useCurrentBreakpoint } from '@travel-frontend/core';
import { IconHelpOutline } from '@travel-frontend/icons';
import { Caption } from '../../../../components/BenefitBanner/components/Item/components/Caption.js';
import { Container } from '../../../../components/BenefitBanner/components/Item/components/Container.js';
import { ImageWrapper } from '../../../../components/BenefitBanner/components/Item/components/Image.js';
import { NextImage } from '../../../../components/internal/NextImage/index.js';
import { Markdown, ParagraphMedium, Stack, Tooltip } from '../../../../primitives/index.js';
import { SPACING_MEDIUM, SPACING_SMALL, SPACING_XSMALL } from '../../../../utils/spacingLegacy.js';
export const Item = ({
  title,
  keyfact,
  description,
  iconUrl,
  short
}) => {
  const lgUp = useBreakpointUp('lg');
  const currentBreakpoint = useCurrentBreakpoint();
  const iconSize = {
    xs: 40,
    sm: 40,
    md: 40,
    lg: 48,
    xl: 70
  }[currentBreakpoint];
  return _jsxs(Container, {
    direction: "row",
    spacing: short ? SPACING_SMALL : SPACING_MEDIUM,
    alignItems: lgUp && !short ? 'flex-start' : 'center',
    children: [_jsx(ImageWrapper, {
      children: _jsx(NextImage, {
        image: iconUrl,
        alt: title,
        width: iconSize,
        height: iconSize,
        loading: "lazy"
      })
    }), _jsx(Caption, {
      children: _jsxs(Stack, {
        spacing: SPACING_XSMALL,
        children: [_jsxs("div", {
          children: [_jsx("span", {
            children: title
          }), _jsx(Tooltip, {
            placement: "top",
            content: _jsx(Markdown, {
              value: description
            }),
            interactive: true,
            tooltipText: description.slice(0, 100),
            collisionDetection: true,
            // @ts-expect-error TS2322
            tabIndex: 0,
            role: "tooltip",
            "aria-label": "Benefits",
            children: _jsx(IconHelpOutline, {
              fontScale: "small"
            })
          })]
        }), !short && _jsx(ParagraphMedium, {
          color: "contentSecondary",
          children: _jsx(Markdown, {
            value: keyfact,
            isInline: true
          })
        })]
      })
    })]
  });
};